import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/casestudy';
import PageLayout from '@/components/PageLayout';
import CaseStudyPC from '@/components/CaseStudy';
import CaseStudyH5 from '@/componentsH5/CaseStudy';

export default function CaseStudy({ SEO }: any) {
    const { useRouter, useLang, useEffect, isMobile } = useGlobal();
    const { t } = useLang('casestudy');
    const router = useRouter();
    const { locale } = router;
    const Layout = isMobile ? CaseStudyH5 : CaseStudyPC;
    useEffect(() => {
        // 仅限jp
        if (!['jp'].includes(locale)) {
            router.push('/404');
        }
    }, []);
    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <PageLayout>
                <Layout />
            </PageLayout>
        </>
    );
}
